import React from "react";
import { capitalize, map } from "lodash";
import { businessTypeOpt } from "../../../helpers/constants";
import { Col } from "reactstrap";
import PropTypes from 'prop-types';

/*(2 = autoplan, 1 = autorenuevate)*/
const BusinessForm = ({
  handleBusinessChange,
  businessTypeName,
  productoSelected,
  businessType,
  carProducts,
  loading,
  isMoto,
  disabled
}) => {
  return (
    <>
      <Col>
        <div className="form-group">
          <label className="labe-simulation-home">
            Tipo de negocio
          </label>
          <select
            required
            onChange={handleBusinessChange}
            value={businessType}
            id="businessType"
            name="businessType"
            className="form-control"
            disabled={carProducts?.length <= 1 || isMoto || loading || disabled}
          >
            {map(businessTypeOpt, (e) => (
              <option key={`business-${e.value}`} value={e.value}>{e.text}</option>
            ))}
          </select>
        </div>
      </Col>
      <Col className="sm-business-selected-container">
        <div className="form-group">
          <label className="labe-simulation-home">
            Producto Seleccionado
          </label>
          <p>{capitalize(productoSelected?.DesProducto || businessTypeName)}</p>
        </div>
      </Col>
    </>
  );
};
BusinessForm.propTypes = {
  handleBusinessChange: PropTypes.func.isRequired,
  businessTypeName: PropTypes.string.isRequired,
  productoSelected: PropTypes.object,
  businessType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  carProducts: PropTypes.array.isRequired, // Added validation for carProducts
  loading: PropTypes.bool.isRequired,
  isMoto: PropTypes.bool.isRequired, // Added validation for isMoto
  disabled: PropTypes.bool.isRequired,
};
export default BusinessForm;